import React from 'react';
import './Popupreject.css'; // Assuming you have some CSS for styling
import CheckmarkIcon from '../../assets/Tick Circle.svg';
import { Button, Box, Typography } from '@mui/material';

interface PopupProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
  buttonText?: string;
  onButtonClick: () => void;
}

const Popupsuccess: React.FC<PopupProps> = ({
  title,
  message,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Box
      className="popupreject"
      sx={{
        position: 'relative',
       backdropFilter:"blur(58px)",
        borderRadius: '34px', 
        backgroundColor: 'rgba(255, 255, 255, 0.1)', 
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0, // Set all sides to 0, keeping it inside the box
          padding: '1px', // Thickness of the border
          borderRadius: 'inherit', // Ensure border-radius matches the container
          background: 'linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%)', // Gradient border effect
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)', // Mask to create the border effect
          maskComposite: 'exclude', // Use to ensure gradient acts as a border
          pointerEvents: 'none', // Allows clicks on the underlying content
          },
           px: { xs: '40px', sm: '40px' },
           py: 4,
            width: { xs: '250px', sm: '350px', md: '350px', xl: '350px' },
            }}>
      <Box 
        sx={{
          gap: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <img alt="tickicon" src={CheckmarkIcon} className="checkmark-icon" />
        {title && (
          <Typography
            variant="h6"
            className="popup-title"
            sx={{ lineHeight: '1.4' }}
          >
            {title}
          </Typography>
        )}
        {message && (
          <Typography variant="body2" className="popup-message">
            {message}
          </Typography>
        )}
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            className="popup-button"
            onClick={onButtonClick}
            sx={{
              fontFamily: 'Opensans',
              backgroundColor: 'rgba(251, 80, 18, 1)',
              '&:hover': { backgroundColor: 'rgba(251, 80, 18, 1)' },
              borderRadius: '38px',
              textTransform: 'none',
              padding: '11px 28px',
            }}
          >
            {buttonText || 'Continue'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Popupsuccess;
